import React, { Fragment, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { changesSlice, changesSubslice } from "redux/features/changes";
import { RESOURCE_TYPE_EMAIL_ADDRESS } from "redux/typeConstants";

import { Button } from "react-bulma-components";
import { RadioColumns } from "util/optionColumns";

function ActivityList({ intro, list, show, setShow }) {
  return (
    <Fragment>
      {list.length > 2 ? (
        <div className="activity summary">
          {intro ? (
            <Fragment>
              <span className="activity-email">{intro}</span>, linked to
            </Fragment>
          ) : (
            "Linked to"
          )}{" "}
          {list.length} Fields Institute events/programs.{" "}
          <Button
            className="is-ghost"
            onClick={(e) => setShow((showing) => !showing)}
          >
            {show ? "Hide them" : "Show them"}
          </Button>
        </div>
      ) : null}
      {list.length <= 2 || show
        ? list.map((a, index) => (
            <div
              key={index}
              className={
                intro && list.length <= 2 && index === 0
                  ? "activity body intro"
                  : "activity body"
              }
            >
              {intro && list.length <= 2 ? (
                index > 0 ? (
                  "and "
                ) : (
                  <Fragment>
                    <span className="activity-email">{intro}</span>,{" "}
                  </Fragment>
                )
              ) : null}
              {a}
            </div>
          ))
        : null}
    </Fragment>
  );
}

function ResolveSingleProfileSharingEmail({
  address,
  otherPerson,
  editState,
  curMerge,
  setMerge,
}) {
  const radioName = "email-merge-" + otherPerson.id;
  const fullName = otherPerson.full_name;
  const affiliations = [
    ...otherPerson.current_affiliations,
    ...otherPerson.past_affiliations.map((n) => `(formerly) ${n}`),
  ];

  const activities = [
    ...[...otherPerson.activities.current].reverse(),
    ...otherPerson.activities.past,
  ];

  const otherEmails = otherPerson.other_email_addresses.map(
    (info) => info.address
  );
  const allActivities = activities.map(
    (info) => `${info.role} ${info.description}`
  );
  const singleEmail = otherEmails.length === 0;

  const sameEmailActivities = singleEmail
    ? []
    : activities
        .map((info) => {
          const sameEmailRegistrations = info.registered_as.filter(
            (as) => as.address.toUpperCase() === address.toUpperCase()
          );
          if (sameEmailRegistrations.length === 0) return null;
          const names = new Set();
          sameEmailRegistrations.forEach((reg) => {
            if (reg.name !== "" && reg.name !== null) names.add(reg.name);
          });
          const nameText =
            names.size > 0
              ? `(as ${Array.from(names.values()).join(", ")}) `
              : "";

          return `${nameText}${info.role} ${info.description}`;
        })
        .filter((description) => description !== null);

  const otherEmailTypes = {};
  const otherEmailActivities = [];
  if (!singleEmail)
    activities.forEach((activityInfo) => {
      let haveOtherEmail = false;
      let haveNoEmail = activityInfo.registered_as.length === 0;
      activityInfo.registered_as.forEach((as) => {
        if (as.address === "") haveNoEmail = true;
        else if (as.address.toUpperCase() !== address.toUpperCase())
          haveOtherEmail = true;
      });
      if (haveOtherEmail) otherEmailTypes.other = true;
      if (haveNoEmail) otherEmailTypes.unspecified = true;
      if (haveOtherEmail || haveNoEmail)
        otherEmailActivities.push(
          `${activityInfo.role} ${activityInfo.description}`
        );
    });

  const splitActivityList =
    otherEmails.length > 0 &&
    sameEmailActivities.length > 0 &&
    otherEmailActivities.length > 0;

  const [showAllActivities, setShowAllActivities] = useState(false);
  const [showSameEmailActivities, setShowSameEmailActivities] = useState(false);
  const [showOtherEmailActivities, setShowOtherEmailActivities] = useState(
    false
  );

  const otherEmailIntro = otherEmailTypes.unspecified
    ? "other or unspecified e-mail addresses"
    : otherEmails.length === 1
    ? "the other e-mail address"
    : "other e-mail addresses";

  return (
    <div className="email-dup-profile">
      <div className="name-header">
        <b>{fullName}</b>
        {affiliations.length > 0 ? (
          <Fragment>, {affiliations.join(", ")}</Fragment>
        ) : null}
      </div>
      <div className="info-body">
        {otherEmails.length > 0 ? (
          <div className="other-emails">
            <i>Other e-mails: {otherEmails.join(", ")}</i>
          </div>
        ) : null}

        {allActivities.length > 0 && !splitActivityList ? (
          <ActivityList
            list={allActivities}
            show={showAllActivities}
            setShow={setShowAllActivities}
          />
        ) : null}
        {splitActivityList ? (
          <Fragment>
            <ActivityList
              intro={`(a) Using the ${address} e-mail`}
              list={sameEmailActivities}
              show={showSameEmailActivities}
              setShow={setShowSameEmailActivities}
            />

            <ActivityList
              intro={`(b) Using ${otherEmailIntro}`}
              list={otherEmailActivities}
              show={showOtherEmailActivities}
              setShow={setShowOtherEmailActivities}
            />
          </Fragment>
        ) : null}

        <div className="prompt">
          <RadioColumns
            name={radioName}
            onChange={setMerge}
            optionValue=""
            value={curMerge}
          >
            <p>
              This {fullName} <b>is not me</b> (even though my e-mail was used).
              {editState && !editState.shared ? (
                <Fragment>
                  {" "}
                  <span className="has-text-danger">
                    This option requires that the e-mail address be set as
                    "shared" above.
                  </span>
                </Fragment>
              ) : null}
              {!editState ? (
                <Fragment>
                  {" "}
                  Selecting this option will cause this e-mail address to be
                  listed in our database as a "shared address".
                </Fragment>
              ) : null}
            </p>
          </RadioColumns>{" "}
          <RadioColumns
            name={radioName}
            onChange={setMerge}
            value={curMerge}
            optionValue="full"
          >
            <p>
              This {fullName} <b>is me</b>. All registrations above are mine and
              should be merged into my profile.
            </p>
          </RadioColumns>
          {splitActivityList ? (
            <RadioColumns
              name={radioName}
              onChange={setMerge}
              value={curMerge}
              optionValue="partial"
            >
              <p>
                This {fullName} is <b>not me</b> but{" "}
                <b>the (a) registrations above are mine</b> (the ones using{" "}
                {address}). They&mdash;but not the (b) ones &mdash; should be
                moved to my profile.
              </p>
            </RadioColumns>
          ) : null}
        </div>
      </div>
    </div>
  );
}

function ResolveProfilesSharingEmail({
  changeKeys,
  address,
  sharedBy,
  editState,
}) {
  const changeRecords = changesSubslice(
    useSelector(changesSlice.selector),
    changeKeys.id,
    changeKeys.section,
    RESOURCE_TYPE_EMAIL_ADDRESS,
    changeKeys.resourceId
  );

  const changes = changeRecords ? changeRecords.changes : {};
  const dispatch = useDispatch();

  const getCurMerge = (id) => {
    const changed = changes["merge-other-profile-" + id];
    return changed === undefined ? "" : changed;
  };

  const buildSetMerge = (id) => {
    const field = "merge-other-profile-" + id;
    return (value) =>
      dispatch(
        value === ""
          ? changesSlice.actions.clearChanged({ ...changeKeys, field })
          : changesSlice.actions.setChanged({ ...changeKeys, field, value })
      );
  };

  return (
    <Fragment>
      {sharedBy.map((otherPerson) => (
        <ResolveSingleProfileSharingEmail
          key={otherPerson.id}
          address={address}
          otherPerson={otherPerson}
          editState={editState}
          curMerge={getCurMerge(otherPerson.id)}
          setMerge={buildSetMerge(otherPerson.id)}
        />
      ))}
    </Fragment>
  );
}

export default ResolveProfilesSharingEmail;
